import { PlusCircleFilled } from '@ant-design/icons';
import { Timeline } from 'antd';
import { getUserStore } from 'core/modules/users/user.store';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TaskActivityLabel } from './Label';
import { jsx as _jsx } from "react/jsx-runtime";
export var TaskActivityDeleted = function TaskActivityDeleted(_ref) {
  var activity = _ref.activity;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getUserStore = getUserStore(),
      getUserById = _getUserStore.getUserById;

  var user = getUserById(activity.authorId);
  return /*#__PURE__*/_jsx(Container, {
    className: "ant-timeline-item-left",
    label: /*#__PURE__*/_jsx(TaskActivityLabel, {
      title: t('task.progress.deleted'),
      createdAt: activity.createdAt,
      user: user
    }),
    dot: /*#__PURE__*/_jsx(PlusCircleFilled, {})
  });
}; // Styles

var Container = styled(Timeline.Item).withConfig({
  displayName: "Deleted__Container",
  componentId: "sc-1lvqbqa-0"
})(["min-height:70px;"]);